<div class="p-10 h-full">
    <nz-page-header class="text-[16px] font-semibold p-0 pb-2 m-0" nzTitle="Rutas de producción">
        <nz-page-header-extra class="flex">
            <nz-space>
                @if (canCreate()) {
                <button class="button primary-button" (click)="create()">
                    Añadir
                </button>
                }
            </nz-space>
        </nz-page-header-extra>
    </nz-page-header>


    <nz-table #routesTable nzTableLayout="auto" nzSize="small" [nzData]="routes" [nzLoading]="isLoading"
        [nzLoadingIndicator]="indicatorTemplate" [nzBordered]="true">
        <thead>
            <tr>
                <th nzWidth="300px">Nombre</th>
                <th nzWidth="300px">Descripción</th>
                @if (canRead() || canEdit() || canDelete()) {
                <th nzWidth="200px">Acciones</th>
                }
            </tr>
        </thead>
        <tbody>
            @for (data of routesTable.data; track data) {
            <tr>
                <td>{{ data.name }}</td>
                <td>{{ data.description }}</td>
                @if (canRead() || canEdit() || canDelete()) {
                <td>
                    <div class="flex align-middle justify-center">
                        @if (canRead()) {
                        <button nz-button nzType="text" nzShape="circle" class="table-icon"
                            [nzTooltipTitle]="'Ver ruta'" nzTooltipPlacement="bottom" nz-tooltip (click)="view(data)">
                            <span nz-icon nzType="eye"></span>
                        </button>
                        @if (canEdit() || canDelete()) {
                        <nz-divider nzType="vertical"></nz-divider>
                        }
                        }

                        @if (canEdit()) {
                        <button nz-button nzType="text" nzShape="circle" class="table-icon"
                            [nzTooltipTitle]="'Editar ruta'" nzTooltipPlacement="bottom" nz-tooltip
                            (click)="edit(data)">
                            <span nz-icon nzType="edit"></span>
                        </button>
                        @if (canDelete()) {
                        <nz-divider nzType="vertical"></nz-divider>
                        }
                        }

                        @if (canDelete()) {
                        <button nz-button nzType="text" nzShape="circle" class="table-icon"
                            [nzTooltipTitle]="'Eliminar ruta'" nzTooltipPlacement="bottom" nz-tooltip
                            (click)="delete(data.id!)">
                            <span nz-icon nzType="delete"></span>
                        </button>
                        }
                    </div>
                </td>
                }
            </tr>
            }
        </tbody>
    </nz-table>
</div>

<ng-template #indicatorTemplate>
    <app-loader></app-loader>
</ng-template>

<nz-drawer [nzClosable]="false" [nzVisible]="drawerVisible" nzPlacement="right" [nzTitle]="title" [nzFooter]="footer"
    (nzOnClose)="closeDrawer()" [nzPlacement]="innerWidth > DRAWER_WIDTH_CHANGE_PLACEMENT ? 'right':'bottom'"
    [nzWidth]="'500px'" [nzHeight]="innerWidth > DRAWER_WIDTH_CHANGE_PLACEMENT ? '' : '90%'"
    [nzMaskClosable]="fieldsReadOnly">
    <ng-template #title class="px-0 py-1 w-full grid grid-cols-2 gap-4 place-content-evenly">
        <div style="display: flex; align-items: center;">
            <p class="drawer-title"> {{ drawerTitle }} </p>
        </div>
    </ng-template>
    <ng-container *nzDrawerContent>
        <form nz-form [nzLayout]="'vertical'" [formGroup]="validateForm" (ngSubmit)="submitForm()">
            <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="p-4">
                <nz-form-item nz-col nzXs="24" nzSm="24" nzMd="24" class="px-4">
                    <nz-form-label nzRequired>
                        Nombre
                    </nz-form-label>
                    <nz-form-control nzErrorTip="Indique un nombre para la ruta">
                        <input onfocus="select()" nz-input placeholder="Indique un nombre para la ruta" type="text"
                            id="name" formControlName="name" />
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item nz-col nzXs="24" nzSm="24" nzMd="24" class="px-4">
                    <nz-form-label>
                        Descripción
                    </nz-form-label>
                    <nz-form-control>
                        <input onfocus="select()" nz-input placeholder="Indique una descripción para la ruta"
                            type="text" id="description" formControlName="description" />
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item nz-col nzXs="24" nzSm="24" nzMd="24" class="px-4">
                    <nz-form-label>
                        Procesos de producción
                    </nz-form-label>
                    <nz-form-control>
                        <nz-select [nzMaxTagCount]="5" [nzMaxTagPlaceholder]="tagPlaceHolder" nzMode="multiple"
                            nzPlaceHolder="Seleccione los procesos productivos de la ruta"
                            [ngModel]="selectedProcessess" (ngModelChange)="onProductionProcessessChange($event)"
                            name="ppSelector" [ngModelOptions]="{standalone: true}" [nzDisabled]="fieldsReadOnly">
                            @for (pp of productionProcesses; track pp.id) {
                            <nz-option [nzLabel]="pp.name" [nzValue]="pp"></nz-option>
                            }
                        </nz-select>
                        <ng-template #tagPlaceHolder let-selectedList>y {{ selectedList.length }} más
                            seleccionados</ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <nz-table class="px-4" nzTableLayout="auto" nzSize="small"
                [nzData]="productionProcessTableRows ? productionProcessTableRows : []" [nzFrontPagination]="false"
                [nzShowPagination]="false" [nzBordered]="true">
                <thead>
                    <tr>
                        <th colspan="3">
                            @if (!fieldsReadOnly) {
                            Orden de los procesos <span style="color:var(--app-terciary-color);">(Arrastra para
                                reordenar)</span>
                            }
                            @else {
                            Orden de los procesos
                            }
                        </th>
                    </tr>
                    <tr>
                        <th>Nº</th>
                        <th>Proceso</th>
                        <th [hidden]="fieldsReadOnly">Acciones</th>
                    </tr>
                </thead>
                <tbody cdkDropList (cdkDropListDropped)="drop($event)">
                    @for (data of productionProcessTableRows; track idx; let idx = $index) {
                    <tr cdkDrag>
                        <td>{{ idx + 1 + 'º' }}</td>
                        <td>{{ data.name }}</td>
                        <td [hidden]="fieldsReadOnly">
                            <div class="flex align-middle justify-center">
                                <button nz-button nzType="text" nzShape="circle" class="table-icon"
                                    [nzTooltipTitle]="'Duplicar proceso'" nzTooltipPlacement="bottom" nz-tooltip
                                    (click)="cloneProductionOrderProcess(idx)">
                                    <span nz-icon nzType="copy"></span>
                                </button>
                                <nz-divider nzType="vertical"></nz-divider>
                                <button nz-button nzType="text" nzShape="circle" class="table-icon"
                                    [nzTooltipTitle]="'Eliminar proceso'" nzTooltipPlacement="bottom" nz-tooltip
                                    (click)="removeProductionProcess(idx)">
                                    <span nz-icon nzType="delete"></span>
                                </button>
                            </div>
                        </td>
                    </tr>
                    }
                </tbody>
            </nz-table>
        </form>
    </ng-container>
    <ng-template #footer>
        <div class="flex justify-end">
            <button class="button secondary-button mr-2" (click)="cancelEditing()">
                Cancelar
            </button>

            @if (!fieldsReadOnly) {
                <button nz-button class="button primary-button" [disabled]="!validateForm.valid" (click)="submitForm()" [nzLoading]="isSaving">
                    Guardar
                </button>
            }
        </div>
    </ng-template>
</nz-drawer>